import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import PrimeVue from 'primevue/config'
import CopyrightFooter from './components/CopyrightFooter.vue'
import 'prismjs/themes/prism.css'


const app = createApp(App);

app.config.globalProperties.$myStaticFunction = () => {
    // Your static-like function implementation
    console.log('This is a static-like function');
};

app.component('CopyrightFooter', CopyrightFooter);

app.use(router)
   .use(bootstrap)
   .use(PrimeVue, {
        unstyled: true
   })
   .mount('#app')
